import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { RecordingTableData } from "../../recording-library.component";

@Component({
  selector: "onsip-recording-shelf-view",
  templateUrl: "./recording-shelf-view.component.html",
  styleUrls: [
    "./recording-shelf-view.component.scss",
    "../recording-shelf-container.component.scss"
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RecordingShelfViewComponent {
  @Input() recording!: RecordingTableData;
  @Output() editPanel = new EventEmitter<void>();

  togglePanel(): void {
    this.editPanel.emit();
  }
}
